import errorCodes from './errorCodes';

export default class HTTPError extends Error {
  statusCode: number;

  title: string;

  failedService?: string;

  constructor(
    statusCode: number,
    title: string,
    message: string,
    failedService?: string
  ) {
    super(message);
    this.statusCode = statusCode;
    this.title = title;
    this.failedService = failedService;
  }

  static requestCancelled(message: string): HTTPError {
    return new HTTPError(
      errorCodes.requestCancelled,
      'Request Cancelled',
      message
    );
  }

  static sessionExpired(): HTTPError {
    return new HTTPError(
      errorCodes.expiredSession,
      'Session expired',
      'Your session expired please log in again.'
    );
  }

  static responseError(): HTTPError {
    return new HTTPError(
      errorCodes.responseError,
      'Response Error',
      'Malformed JSON response'
    );
  }

  static invalidData(): HTTPError {
    return new HTTPError(
      errorCodes.invalidData,
      'Invalid Data',
      'The provided data is invalid'
    );
  }

  static stripeError(message: string): HTTPError {
    return new HTTPError(errorCodes.stripeError, 'Stripe Error', message);
  }

  static mediaError(message: string): HTTPError {
    return new HTTPError(errorCodes.mediaError, 'Media error', message);
  }

  static typeError(message: string): HTTPError {
    return new HTTPError(errorCodes.typeError, 'Type error', message);
  }
}
